import { PhxBadgeModule, PhxDividerModule, PhxIconModule, PhxTooltipModule, PhxButtonModule } from 'phx-core';

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

import { CommonModule } from '../common.module';
import { FormErrorModule } from '../form-error/module';
import { CompanySwitcherModule } from './company-switcher/module';
import { SkeletonModule } from '@misc/skeleton.module';
import { PageHeaderModule } from '@misc/page-header/page-header.module';
import { GroupsMultiSelectFilterModule } from '@misc/groups-multi-select-filter/module';
import { UpsellModule } from '@misc/upsell/module';
import { ScrollModule } from '@app/scroll/module';
import { RadioGroupStretcherModule } from '@app/admin/alerts-platform/radio-group-stretcher/radio-group-stretcher.module';
import { AccordionModule } from '@app/misc/accordion.module';
import { TopbarModule } from './topbar/topbar.module';
import { TosModalModule } from '@app/admin/fleet-card/shared/tos-modal/module';
import { ExpansionUpsellsModule } from '@misc/upsell/expansion-upsells/module';

import { FlashMessageComponent } from './flash-message.component';
import { BreadcrumbComponent } from './breadcrumb.component';
import { EldOnboardingBannerComponent } from './eld-onboarding-banner.component';
import { UnsupportedBrowserBannerComponent } from './unsupported-browser-banner.component';
import { FleetcardApplicationNudgeBannerComponent } from './fleetcard-application-nudge-banner.component';
import { FleetcardTOSBannerComponent } from './fleetcard-tos-banner.component';
import { IeNotSupportedBannerComponent } from './ie-not-supported-banner.component';
import { RemoteLoginBarComponent } from './remote-login-bar.component';
import { TimeZoneBannerComponent } from './time-zone-banner.component';
import { TopBannerComponent } from './top-banner.component';
import { ReferralModalComponent } from './referral-modal.component';
import { NewSidebarComponent } from './sidebar-2.0/sidebar.component';
import { AvatarDropdownComponent } from './avatar-dropdown.component';
import { SupportMenuComponent } from './support-menu.component';
import { DashboardAdminSwitcherComponent } from './dashboard-admin-switcher.component';
import { QuickActionModalComponent } from './quick-actions/quick-action.component';
import { NotificationCenterComponent } from './notification-center/notification-center.component';
import { NotificationItemComponent } from './notification-center/notification-item.component';
import { NoResultsComponent } from './notification-center/no-results.component';
import { AdaChatbotComponent } from '@app/common-components/ada-chatbot.component';
import { UpsellPendoGuideComponent } from '@misc/upsell/upsell-pendo-guide.component';
import { NotificationItemPreviewComponent } from './notification-center/notification-item-preview.component';
import { RefreshOverlayComponent } from './refresh-overlay/refresh-overlay.component';
import { StickPromoBannerComponent } from './sticky-promo-banner/sticky-promo-banner.component';

import { UnreadNotificationsPipe } from './notification-center/unread-notifications-count.pipe';
import { UnseenNotificationsPipe } from './notification-center/unseen-notifications-count.pipe';
import { ImportantNotificationsPipe } from './notification-center/important-notifications-count.pipe';
import { MetricUnitsPipe } from '../pipes/metric-units';

import { GroupsFilter } from '@services/groups-filter';
import { Breadcrumb } from '@services/breadcrumb';
import { FlashMessage } from '@services/flash-message';
import { ReferralModal } from '@services/referral-modal';
import { SupportContact } from '@services/support-contact';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {};

const COMPONENTS = [
  FlashMessageComponent,
  ReferralModalComponent,
  BreadcrumbComponent,
  NewSidebarComponent,
  AvatarDropdownComponent,
  SupportMenuComponent,
  DashboardAdminSwitcherComponent,
  QuickActionModalComponent,
  AdaChatbotComponent,
  NotificationCenterComponent,
  NotificationItemComponent,
  NotificationItemPreviewComponent,
  NoResultsComponent,
  EldOnboardingBannerComponent,
  UnsupportedBrowserBannerComponent,
  FleetcardApplicationNudgeBannerComponent,
  FleetcardTOSBannerComponent,
  IeNotSupportedBannerComponent,
  RemoteLoginBarComponent,
  TimeZoneBannerComponent,
  TopBannerComponent,
  RefreshOverlayComponent,
  UnreadNotificationsPipe,
  UnseenNotificationsPipe,
  ImportantNotificationsPipe,
  UpsellPendoGuideComponent,
  StickPromoBannerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PhxBadgeModule,
    PhxIconModule,
    PhxTooltipModule,
    PhxDividerModule,
    AccordionModule,
    FormErrorModule,
    ScrollingModule,
    ExperimentalScrollingModule,
    GroupsMultiSelectFilterModule,
    PerfectScrollbarModule,
    NzButtonModule,
    CompanySwitcherModule,
    NzRadioModule,
    SkeletonModule,
    ScrollModule,
    RadioGroupStretcherModule,
    UpsellModule,
    TopbarModule,
    NzPopoverModule,
    PhxTooltipModule,
    PhxButtonModule,
    TosModalModule,
    ExpansionUpsellsModule,
  ],
  declarations: COMPONENTS,
  exports: [
    COMPONENTS,
    UpsellModule,
    TopbarModule,
    PageHeaderModule,
  ],
  providers: [
    Breadcrumb,
    FlashMessage,
    ReferralModal,
    SupportContact,
    GroupsFilter,
    MetricUnitsPipe,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class LayoutCommonVersionModule {}
